import { useState, useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import CartIcon from '@mui/icons-material/AddShoppingCartSharp';
import HomeIcon from '@mui/icons-material/HomeSharp';
import MoneyIcon from '@mui/icons-material/PaidSharp';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import RepIcon from '@mui/icons-material/SummarizeSharp';
import ViewIcon from '@mui/icons-material/AssessmentSharp';
import LogoutSharpIcon from '@mui/icons-material/LogoutSharp';
import InvIcon from '@mui/icons-material/TrendingUp';
import AccountCircle from '@mui/icons-material/AccountCircle';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import DoneIcon from '@mui/icons-material/Done';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import LogoutIcon from '@mui/icons-material/Logout';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import AutoModeIcon from '@mui/icons-material/AutoMode';

import { Menu, MenuItem, Avatar } from '@mui/material';


import Escritorio from './Escritorio';
import Busqueda from './Busqueda';
import Inversionista from './Inversionista';
import Consulta from './Consulta';

import logo from "../images/logo.png"

import useAuth from '../hooks/useAuth';
import axios, { getServerBaseURL } from "../api/axios"

import InversionistaFind from './InversionistaFind';
import Inversiones from './Inversiones';
import Intervalo1 from './Intervalo1';
import Intervalo2 from './Intervalo2';
import Intervalo3 from './Intervalo3';
import Movimientos from './Movimientos';
import RetiroDisponible from './RetiroDisponible';
import RetiroGanancias from './RetiroGanancias';
import MiCuenta from './MiCuenta';
import Oficiales from './Oficiales';
import RetirosView from './RetirosView';
import Intervalo4 from './Intervalo4';
import InversionesAutomaticas from './InversionesAutomaticas';
import CierreInversiones from './CierreInversiones';
import LockClockIcon from '@mui/icons-material/LockClock';

const drawerWidth = 240;


const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
  boxShadow: '0 4px 20px rgba(30, 58, 95, 0.3)',
  borderBottom: '2px solid #d4af37',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // En móvil, el AppBar siempre ocupa todo el ancho
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    width: '100%',
  },
  // En desktop, ajustar según el drawer
  [theme.breakpoints.up('md')]: {
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  },
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': {
        ...openedMixin(theme),
        background: 'linear-gradient(180deg, #0d1b2a 0%, #1e3a5f 100%)',
        borderRight: '1px solid #d4af37',
      },
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': {
        ...closedMixin(theme),
        background: 'linear-gradient(180deg, #0d1b2a 0%, #1e3a5f 100%)',
        borderRight: '1px solid #d4af37',
      },
    }),
  }),
);

const rowMenu = [
  { texto: "Mis préstamos", imagen: 1, seleccion: 2 },
  { texto: "Ir a prestar", imagen: 2, seleccion: 3 },
  { texto: "Mis Ganancias", imagen: 4, seleccion: 5 },
  { texto: "Retirar Disponible", imagen: 9, seleccion: 9 },
  { texto: "Retirar Ganancias", imagen: 9, seleccion: 19 },
  { texto: "Consulta Movimientos", imagen: 10, seleccion: 15 },
  { texto: "Consulta Retiros", imagen: 11, seleccion: 16 },
  { texto: "Inversiones Automáticas", imagen: 12, seleccion: 20 }
]

const rowMenuAdm = [
  { texto: "Depósitos", imagen: 1, seleccion: 8 },
  { texto: "Reporte Retiros", imagen: 4, seleccion: 11 },
  { texto: "Reporte Ganancias", imagen: 4, seleccion: 13 },
  { texto: "Resumen Ganancias", imagen: 4, seleccion: 14 },
  { texto: "Rep Ganancias oficiales", imagen: 4, seleccion: 18 },
  { texto: "Crear Inversionistas", imagen: 5, seleccion: 6 },
  { texto: "Crear Oficiales", imagen: 5, seleccion: 12 },
  { texto: "Sel. Inversionista", imagen: 7, seleccion: 7 },
  { texto: "Cierre Inversiones", imagen: 13, seleccion: 21 },
  { texto: "Cerrar Sesión", imagen: 6, seleccion: 99 },
]

export default function MiMenu() {
  const theme = useTheme();
  // Detectar si es dispositivo móvil/tablet
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const [open, setOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false); // Estado para drawer móvil
  const [pinned, setPinned] = useState(() => {
    const saved = localStorage.getItem('menuPinned');
    return saved === 'true';
  });
  // Recuperar la pagina actual del localStorage al iniciar
  const [seleccion, setSeleccion] = useState(() => {
    const savedPage = localStorage.getItem('currentPage');
    return savedPage ? parseInt(savedPage, 10) : 1;
  });
  const { auth, setAuth } = useAuth();
  const [openSeleccionInversionista, setOpenSeleccionInversionista] = useState(false)
  const [inversionistaNombre, setInversionistaNombre] = useState("")
  const [inversionistaFoto, setInversionistaFoto] = useState(null)
  const [anchorEl, setAnchorEl] = useState(null)

  const openMenuUser = Boolean(anchorEl);

  // Funciones para manejar drawer móvil
  const handleMobileDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileDrawerClose = () => {
    setMobileOpen(false);
  };

  // Guardar la pagina actual en localStorage cuando cambie
  useEffect(() => {
    if (seleccion !== 99) { // No guardar si es cierre de sesion
      localStorage.setItem('currentPage', seleccion.toString());
    }
  }, [seleccion]);

  useEffect(() => {
    //    console.log("auth: ", auth)
    actInfoInversionista()
  }, [auth])

  // Recargar info del inversionista cuando se sale de Mi Cuenta (para actualizar la foto)
  useEffect(() => {
    if (seleccion !== 10) { // 10 es Mi Cuenta
      actInfoInversionista()
    }
  }, [seleccion])

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    if (!pinned) {
      setOpen(false);
    }
  };

  const handleTogglePin = () => {
    const newPinned = !pinned;
    setPinned(newPinned);
    localStorage.setItem('menuPinned', newPinned.toString());
    if (newPinned) {
      setOpen(true);
    }
  };

  useEffect(() => {
    if (pinned) {
      setOpen(true);
    }
  }, [pinned]);

  const actInfoInversionista = async () => {
    try {
      const respuesta = await axios.post("inversionista/profileinicio", {
        cual: auth.inversionista
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
      const data = respuesta.data;
      if (data.respuesta == "S") {
        setInversionistaNombre(data.nombre + " " + (data.apellido || ""))
        // Cargar foto si existe
        if (data.foto_url) {
          setInversionistaFoto(`${getServerBaseURL()}${data.foto_url}`)
        } else {
          setInversionistaFoto(null)
        }
        setOpenSeleccionInversionista(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const traeImagen = (cual) => {
    if (cual == 1) { return <MoneyIcon /> }
    if (cual == 2) { return <CartIcon /> }
    if (cual == 3) { return <ViewIcon /> }
    if (cual == 4) { return <RepIcon /> }
    if (cual == 5) { return <PersonAddAltIcon /> }
    if (cual == 6) { return <LogoutSharpIcon /> }
    if (cual == 7) { return <DoneIcon /> }
    if (cual == 8) { return <AssignmentIcon /> }
    if (cual == 9) { return <CurrencyExchangeIcon /> }
    if (cual == 10) { return <TroubleshootIcon /> }
    if (cual == 11) { return <AttachMoneyIcon /> }
    if (cual == 12) { return <AutoModeIcon /> }
    if (cual == 13) { return <LockClockIcon /> }
  }

  const DashOpc = (cual) => {
    if (cual == 1) { setSeleccion(15) }
    if (cual == 2) { setSeleccion(5) }
    if (cual == 3) { setSeleccion(2) }
    if (cual == 4) { setSeleccion(17) }
  }

  const getContenido = (cual) => {
    if (cual == 1) { return <Escritorio opciones={DashOpc} /> }
    if (cual == 2) { return <Inversiones estatus={0}/> }
    if (cual == 5) { return <Intervalo1 reporte={1} /> }
    if (cual == 3) { return <Busqueda /> }
    if (cual == 6) { return <Inversionista cual={0} /> }
    if (cual == 8) { return <Movimientos /> }
    if (cual == 9) { return <RetiroDisponible /> }
    if (cual == 19) { return <RetiroGanancias /> }
    if (cual == 10) { return <MiCuenta cual={auth.inversionista} cerrar={() => { setSeleccion(1) }} /> }
    if (cual == 11) { return <Intervalo2 reporte={2} /> }
    if (cual == 12) { return <Oficiales cual={0} /> }
    if (cual == 13) { return <Intervalo2 reporte={3} /> }
    if (cual == 14) { return <Intervalo3 reporte={4} /> }
    if (cual == 15) { return <Consulta /> }
    if (cual == 16) { return <RetirosView /> }
    if (cual == 17) { return <Inversiones estatus={2}/> }
    if (cual == 18) { return <Intervalo4 reporte={5} /> }
    if (cual == 20) { return <InversionesAutomaticas /> }
    if (cual == 21) { return <CierreInversiones /> }
  }

  const admProceso = (cual) => {
    if (cual == 6) {
      setSeleccion(6)
    } else if (cual == 7) {
      setOpenSeleccionInversionista(true)
    } else if (cual == 8) {
      setSeleccion(cual)
    } else if (cual == 11) {
      setSeleccion(cual)
    } else if (cual == 99) {
      // Guardar indicador de cierre manual antes de limpiar
      localStorage.setItem('logoutReason', 'manual')
      localStorage.removeItem('accessToken')
      localStorage.removeItem('inversionista')
      localStorage.removeItem('nivel')
      localStorage.removeItem('lastActivity')
      localStorage.removeItem('currentPage') // Limpiar pagina guardada al cerrar sesion
      setAuth({
        accessToken: "",
        usuario: 0,
        inversionista: 0,
        nivel: 2
      })
    } else {
      setSeleccion(cual)
    }
  }

  const handleSeleccionInversionista = (cual) => {
    setAuth({
      ...auth,
      inversionista: cual

    })
    localStorage.setItem("inversionista", cual)
  }

  const handleCerrarSeleccionInversionista = () => {
    setOpenSeleccionInversionista(false)
  }

  const MenuUsuario = () => {

    return (
      <Menu
        id="menuUser"
        anchorEl={anchorEl}
        open={openMenuUser}
        onClose={handleCloseMenuUsuario}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => { handleCloseMenuUsuario(); setSeleccion(10) }}>
          <ListItemIcon><AccountBoxIcon fontSize='small' /></ListItemIcon>
          <ListItemText>Mi cuenta</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => { admProceso(99) }}>
          <ListItemIcon><LogoutIcon fontSize='small' /></ListItemIcon>
          <ListItemText>Cerrar Sesión</ListItemText>
        </MenuItem>
      </Menu>
    )
  }

  const handleClickMenuUsuario = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenuUsuario = () => {
    setAnchorEl(null)
  }

  // Contenido del Drawer reutilizable para móvil y desktop
  const DrawerContent = ({ isDrawerOpen, showPinButton = true }) => (
    <>
      <DrawerHeader sx={{ borderBottom: '1px solid rgba(212, 175, 55, 0.3)', justifyContent: 'center', position: 'relative' }}>
        <Box sx={{
          backgroundColor: 'white',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          border: '2px solid #d4af37'
        }}>
          <img src={logo} style={{ height: "38px", width: "38px", objectFit: "contain" }} alt="Logo" />
        </Box>
        {!isMobile && (
          <IconButton onClick={handleDrawerClose} disabled={pinned} sx={{ color: '#d4af37', position: 'absolute', right: 8 }}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        )}
        {isMobile && (
          <IconButton onClick={handleMobileDrawerClose} sx={{ color: '#d4af37', position: 'absolute', right: 8 }}>
            <ChevronLeftIcon />
          </IconButton>
        )}
      </DrawerHeader>
      <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.2)' }} />
      <List>
        <ListItem key={"dashboard"} disablePadding sx={{ display: 'block' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ListItemButton
              onClick={() => { setSeleccion(1); if (isMobile) handleMobileDrawerClose(); }}
              sx={{
                minHeight: 48,
                justifyContent: isDrawerOpen ? 'initial' : 'center',
                px: 2.5,
                flexGrow: 1,
                borderRadius: '4px',
                mx: 1,
                '&:hover': {
                  background: 'rgba(212, 175, 55, 0.15)',
                },
                ...(seleccion === 1 && {
                  background: 'linear-gradient(90deg, rgba(212, 175, 55, 0.2) 0%, rgba(44, 82, 130, 0.2) 100%)',
                  borderLeft: '3px solid #d4af37',
                }),
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: isDrawerOpen ? 3 : 'auto',
                  justifyContent: 'center',
                  color: seleccion === 1 ? '#d4af37' : '#94a3b8',
                }}
              >
                <HomeIcon />
              </ListItemIcon>
              <ListItemText
                primary={"Inicio"}
                sx={{
                  opacity: isDrawerOpen ? 1 : 0,
                  '& .MuiTypography-root': {
                    fontWeight: seleccion === 1 ? 600 : 400,
                    color: seleccion === 1 ? '#d4af37' : '#e2e8f0',
                  }
                }}
              />
            </ListItemButton>
            {isDrawerOpen && showPinButton && !isMobile && (
              <IconButton
                onClick={handleTogglePin}
                title={pinned ? "Desanclar menú" : "Anclar menú"}
                size="small"
                sx={{
                  mr: 1,
                  color: pinned ? '#d4af37' : '#94a3b8',
                  transform: pinned ? 'rotate(45deg)' : 'none',
                  transition: 'all 0.2s',
                  '&:hover': {
                    color: '#d4af37',
                    backgroundColor: 'rgba(212, 175, 55, 0.15)',
                  }
                }}
              >
                {pinned ? <PushPinIcon fontSize="small" /> : <PushPinOutlinedIcon fontSize="small" />}
              </IconButton>
            )}
          </Box>
        </ListItem>
      </List>
      <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.2)' }} />
      <List>
        {rowMenu.map((item, index) => (
          <ListItem key={item.texto} disablePadding sx={{ display: 'block' }} onClick={() => { setSeleccion(item.seleccion); if (isMobile) handleMobileDrawerClose(); }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: isDrawerOpen ? 'initial' : 'center',
                px: 2.5,
                borderRadius: '4px',
                mx: 1,
                my: 0.5,
                '&:hover': {
                  background: 'rgba(212, 175, 55, 0.15)',
                },
                ...(seleccion === item.seleccion && {
                  background: 'linear-gradient(90deg, rgba(212, 175, 55, 0.2) 0%, rgba(44, 82, 130, 0.2) 100%)',
                  borderLeft: '3px solid #d4af37',
                }),
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: isDrawerOpen ? 3 : 'auto',
                  justifyContent: 'center',
                  color: seleccion === item.seleccion ? '#d4af37' : '#94a3b8',
                }}
              >
                {traeImagen(item.imagen)}
              </ListItemIcon>
              <ListItemText
                primary={item.texto}
                sx={{
                  opacity: isDrawerOpen ? 1 : 0,
                  '& .MuiTypography-root': {
                    fontWeight: seleccion === item.seleccion ? 600 : 400,
                    color: seleccion === item.seleccion ? '#d4af37' : '#e2e8f0',
                    fontSize: '0.9rem',
                  }
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider sx={{ borderColor: 'rgba(212, 175, 55, 0.2)' }} />
      <List>
        {rowMenuAdm.filter((item) => { if (auth.nivel == 1) { return true } else { if (item.seleccion == 99) { return true } else { return false } } }).map((item) => (
          <ListItem key={item.texto} disablePadding sx={{ display: 'block' }} onClick={() => { admProceso(item.seleccion); if (isMobile && item.seleccion !== 99) handleMobileDrawerClose(); }} >
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: isDrawerOpen ? 'initial' : 'center',
                px: 2.5,
                borderRadius: '4px',
                mx: 1,
                my: 0.5,
                '&:hover': {
                  background: item.seleccion === 99
                    ? 'rgba(220, 38, 38, 0.2)'
                    : 'rgba(212, 175, 55, 0.15)',
                },
                ...(seleccion === item.seleccion && item.seleccion !== 99 && {
                  background: 'linear-gradient(90deg, rgba(212, 175, 55, 0.2) 0%, rgba(44, 82, 130, 0.2) 100%)',
                  borderLeft: '3px solid #d4af37',
                }),
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: isDrawerOpen ? 3 : 'auto',
                  justifyContent: 'center',
                  color: item.seleccion === 99 ? '#ef4444' : (seleccion === item.seleccion ? '#d4af37' : '#94a3b8'),
                }}
              >
                {traeImagen(item.imagen)}
              </ListItemIcon>
              <ListItemText
                primary={item.texto}
                sx={{
                  opacity: isDrawerOpen ? 1 : 0,
                  '& .MuiTypography-root': {
                    fontWeight: seleccion === item.seleccion ? 600 : 400,
                    color: item.seleccion === 99 ? '#ef4444' : (seleccion === item.seleccion ? '#d4af37' : '#e2e8f0'),
                    fontSize: '0.9rem',
                  }
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </>
  );

  return (
    <Box sx={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%', display: 'flex', background: 'linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 50%, #edf2f7 100%)' }}>
      <CssBaseline />
      <AppBar position="fixed" open={!isMobile && open}>
        <Toolbar sx={{
          minHeight: { xs: 60, sm: 68, md: 76 },
          px: { xs: 1, sm: 1.5, md: 2 }
        }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={isMobile ? handleMobileDrawerToggle : handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: { xs: 0.5, sm: 2, md: 5 },
              padding: { xs: '6px', sm: '8px' },
              ...(!isMobile && open && { display: 'none' }),
            }}
          >
            <MenuIcon sx={{ fontSize: { xs: '22px', sm: '24px' } }} />
          </IconButton>

          <Box sx={{ flexGrow: 1, position: "relative", display: "flex", alignItems: "center" }}>
            {/* Logo - visible en todas las pantallas */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{
                backgroundColor: 'white',
                borderRadius: '50%',
                width: { xs: '42px', sm: '52px', md: '58px' },
                height: { xs: '42px', sm: '52px', md: '58px' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                border: { xs: '1.5px solid #d4af37', sm: '2px solid #d4af37' }
              }}>
                <Box
                  component="img"
                  src={logo}
                  alt="Logo"
                  sx={{
                    height: { xs: '32px', sm: '40px', md: '44px' },
                    width: { xs: '32px', sm: '40px', md: '44px' },
                    objectFit: 'contain'
                  }}
                />
              </Box>
            </Box>

            {/* Info del usuario - responsive */}
            <Box sx={{
              position: "absolute",
              right: { xs: 0, sm: "10px" },
              top: "50%",
              transform: "translateY(-50%)",
              display: "flex",
              alignItems: "center",
              gap: { xs: '4px', sm: '10px', md: '15px' }
            }}>
              <MenuUsuario />
              {/* Nombre inversionista - visible en todas las pantallas */}
              <Box sx={{
                display: 'flex',
                flexDirection: "column",
                alignItems: "flex-end"
              }}>
                {/* Etiqueta "Inversionista:" solo en pantallas grandes */}
                <Typography variant='body2' sx={{
                  display: { xs: 'none', sm: 'block' },
                  fontSize: { sm: '0.7rem', md: '0.875rem' },
                  opacity: 0.9
                }}>
                  Inversionista:
                </Typography>
                {/* Nombre del inversionista - visible en todas las pantallas */}
                <Typography variant='body2' sx={{
                  fontSize: { xs: '0.65rem', sm: '0.8rem', md: '1rem' },
                  maxWidth: { xs: '70px', sm: '100px', md: '200px' },
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontWeight: { xs: 600, sm: 500 }
                }}>
                  {inversionistaNombre}
                </Typography>
              </Box>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleClickMenuUsuario}
                sx={{
                  padding: 0,
                  '&:hover': {
                    backgroundColor: 'transparent',
                  }
                }}
              >
                <Avatar
                  src={inversionistaFoto}
                  sx={{
                    width: { xs: '42px', sm: '50px', md: '56px' },
                    height: { xs: '42px', sm: '50px', md: '56px' },
                    border: { xs: '2px solid #d4af37', sm: '3px solid #d4af37' },
                    backgroundColor: '#e2e8f0',
                    color: '#1e3a5f',
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    '&:hover': {
                      boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                    }
                  }}
                >
                  {!inversionistaFoto && inversionistaNombre ? inversionistaNombre.charAt(0).toUpperCase() : ''}
                </Avatar>
              </IconButton>
            </Box>

          </Box>

        </Toolbar>
      </AppBar>
      {/* Drawer para móvil - SwipeableDrawer */}
      {isMobile && (
        <SwipeableDrawer
          variant="temporary"
          open={mobileOpen}
          onOpen={() => setMobileOpen(true)}
          onClose={handleMobileDrawerClose}
          ModalProps={{
            keepMounted: true, // Mejor rendimiento en móvil
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              background: 'linear-gradient(180deg, #0d1b2a 0%, #1e3a5f 100%)',
              borderRight: '1px solid #d4af37',
            },
          }}
        >
          <DrawerContent isDrawerOpen={true} showPinButton={false} />
        </SwipeableDrawer>
      )}

      {/* Drawer para desktop - Drawer permanente */}
      {!isMobile && (
        <Drawer
          variant="permanent"
          open={open}
          onMouseEnter={() => { if (!pinned) setOpen(true); }}
          onMouseLeave={() => { if (!pinned) setOpen(false); }}
          sx={{
            display: { xs: 'none', md: 'block' },
          }}
        >
          <DrawerContent isDrawerOpen={open} showPinButton={true} />
        </Drawer>
      )}

      {/* Área de contenido principal - responsive */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, sm: 1.5, md: 3 },
          marginTop: { xs: "60px", sm: "68px", md: "76px" },
          marginBottom: { xs: "56px", md: 0 }, // Espacio para BottomNavigation en móvil
          overflow: 'auto',
          height: { xs: 'calc(100vh - 116px)', sm: 'calc(100vh - 124px)', md: 'calc(100vh - 76px)' },
          '& .MuiCard-root': {
            borderRadius: { xs: 2, md: 3 },
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            border: '1px solid rgba(0,0,0,0.05)',
          },
          '& .MuiButton-contained': {
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
          },
          // Ajustar tablas para móvil
          '& .MuiTableContainer-root': {
            overflowX: 'auto',
          },
          '& .MuiDataGrid-root': {
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
          },
        }}
      >
        {openSeleccionInversionista ? <InversionistaFind open={openSeleccionInversionista} seleccion={handleSeleccionInversionista} cerrar={handleCerrarSeleccionInversionista} /> : null}
        {getContenido(seleccion)}
      </Box>

      {/* Bottom Navigation para móvil */}
      {isMobile && (
        <Paper
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: theme.zIndex.drawer + 2,
            borderTop: '2px solid #d4af37',
          }}
          elevation={3}
        >
          <BottomNavigation
            value={seleccion === 1 ? 0 : seleccion === 2 ? 1 : seleccion === 5 ? 2 : seleccion === 15 ? 3 : 4}
            onChange={(event, newValue) => {
              if (newValue === 0) setSeleccion(1);
              else if (newValue === 1) setSeleccion(2);
              else if (newValue === 2) setSeleccion(5);
              else if (newValue === 3) setSeleccion(15);
              else if (newValue === 4) handleMobileDrawerToggle();
            }}
            sx={{
              background: 'linear-gradient(180deg, #0d1b2a 0%, #1e3a5f 100%)',
              height: 56,
              '& .MuiBottomNavigationAction-root': {
                color: '#94a3b8',
                minWidth: 'auto',
                padding: '6px 0',
                '&.Mui-selected': {
                  color: '#d4af37',
                },
                '& .MuiBottomNavigationAction-label': {
                  fontSize: '0.65rem',
                  '&.Mui-selected': {
                    fontSize: '0.7rem',
                  }
                }
              },
            }}
            showLabels
          >
            <BottomNavigationAction
              label="Inicio"
              icon={<HomeIcon />}
            />
            <BottomNavigationAction
              label="Préstamos"
              icon={<MoneyIcon />}
            />
            <BottomNavigationAction
              label="Ganancias"
              icon={<RepIcon />}
            />
            <BottomNavigationAction
              label="Movimientos"
              icon={<TroubleshootIcon />}
            />
            <BottomNavigationAction
              label="Más"
              icon={<MoreHorizIcon />}
            />
          </BottomNavigation>
        </Paper>
      )}
    </Box>
  );
}
